/**
 * `SheetsNetwork` — the rows package's wire-protocol namespace: the generated
 * types for `@tento/lona/sheets`' HTTP boundary (row / sheet / cell / calendar
 * / task routes). The ONE declaration of every wire type `@tento/lona`'s
 * `Network` shares with it: the generator writes those as aliases of these
 * (`export type X = SheetsNetwork.X`, `share_components`); only the route map
 * is written twice (its parity: `src/_network-type-check.ts`). The name stays
 * `SheetsNetwork`, not `Network`: `@tento/lona/network` publishes `Network`,
 * and one exported name is one declaration.
 *
 * `../network.ts` is emitted by `tsh.lona lona lona-admin gen.ts`, whose
 * TypeScript writer always names the namespace `Network`. Giving it the
 * package-qualified name here (rather than in the generated file) keeps the
 * name stable across regenerations; every module in this package imports
 * `SheetsNetwork` from this file, never `Network` from `../network`.
 */
export { Network as SheetsNetwork } from "../network.ts";
